document.addEventListener('click', function (e) {
  const btn = e.target.closest('.ajax-add-to-cart');
  if (!btn) return;

  const card = btn.closest('.addtocart-row-form');
  const qtyInput = card.querySelector('.qty-input');

  const variantId = btn.dataset.variantId;
  const quantity = parseInt(qtyInput?.value || 1, 10);

  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add failed');
    return fetch('/cart.js');
  })
  .then(res => res.json())
  .then(cart => {
    btn.textContent = 'ADDED';

    /* ✅ HORIZON EVENT (THIS IS THE FIX) */
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            source: 'collection',
            itemCount: cart.item_count,
            variantId: variantId
          }
        }
      })
    );

    setTimeout(() => {
      btn.textContent = 'ADD';
      btn.disabled = false;
    }, 1200);
  })
  .catch(() => {
    btn.textContent = 'Error';
    btn.disabled = false;
  });
});
